var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgElergone(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "logo_elergone",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 120 32",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#1a171b;}.cls-2{fill:url(#linear-gradient);}"), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    y1: 16,
    x2: 25.97,
    y2: 16,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#009ddf"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#172982"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "symbol_text",
    "data-name": "symbol + text"
  }, /*#__PURE__*/React.createElement("g", {
    id: "text"
  }, /*#__PURE__*/React.createElement("g", {
    id: "elergone"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M31.55,17.24a1.9,1.9,0,0,0,2.16,1.81,5.29,5.29,0,0,0,1.94-.31L35.91,20a6.69,6.69,0,0,1-2.45.45,3.32,3.32,0,0,1-3.6-3.56c0-1.94,1.17-3.77,3.42-3.77s3,1.87,3,3.41a5.86,5.86,0,0,1,0,.75ZM34.63,16a1.51,1.51,0,0,0-1.46-1.71A1.72,1.72,0,0,0,31.55,16Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M37,10h1.78V20.25H37Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M41.22,17.24a1.9,1.9,0,0,0,2.16,1.81,5.29,5.29,0,0,0,1.94-.31L45.58,20a6.69,6.69,0,0,1-2.45.45,3.32,3.32,0,0,1-3.6-3.56c0-1.94,1.17-3.77,3.42-3.77s3,1.87,3,3.41a4.45,4.45,0,0,1-.05.75ZM44.3,16a1.51,1.51,0,0,0-1.45-1.71A1.73,1.73,0,0,0,41.22,16Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M46.67,15.5c0-.95,0-1.63-.06-2.26h1.54l.06,1.34h0a2.09,2.09,0,0,1,1.92-1.5,2.48,2.48,0,0,1,.41,0v1.67a2.4,2.4,0,0,0-.52,0,1.56,1.56,0,0,0-1.58,1.33,3,3,0,0,0-.05.55v3.63H46.67Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M57.29,19.23a4.06,4.06,0,0,1-1,3.18,4.06,4.06,0,0,1-2.7.85,4.87,4.87,0,0,1-2.44-.57l.39-1.33a4.3,4.3,0,0,0,2,.53,1.86,1.86,0,0,0,2-2.12v-.6h0a2.35,2.35,0,0,1-2,1c-1.74,0-3-1.43-3-3.42,0-2.3,1.49-3.7,3.17-3.7a2.22,2.22,0,0,1,2,1.09h0l.07-.93h1.54c0,.47-.06,1-.06,2Zm-1.77-3.18a1.51,1.51,0,0,0-.06-.48A1.46,1.46,0,0,0,54,14.43c-1,0-1.73.87-1.73,2.29,0,1.2.61,2.16,1.71,2.16a1.51,1.51,0,0,0,1.44-1.06,3.39,3.39,0,0,0,.07-.64Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M65.54,16.64a3.58,3.58,0,0,1-3.83,3.77A3.52,3.52,0,0,1,58,16.75,3.57,3.57,0,0,1,61.86,13,3.48,3.48,0,0,1,65.54,16.64Zm-4.9.07c0,1.05.34,1.87,1.15,1.87s1.07-.74,1.07-1.87-.31-1.87-1.09-1.87S60.64,15.77,60.64,16.71Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M66.07,15.57c0-.93,0-1.75-.06-2.4h2.23l.11.9h.06A2.54,2.54,0,0,1,70.52,13c1.66,0,2.55,1.12,2.55,3.06v4.18H70.48V16.39c0-.82-.29-1.29-.91-1.29a.88.88,0,0,0-.84.61,1.39,1.39,0,0,0-.08.52v4H66.07Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M76.06,17.61c.08.57.9.88,1.81.88a6.36,6.36,0,0,0,1.94-.27L80.14,20a7.15,7.15,0,0,1-2.65.46C75,20.41,73.6,19,73.6,16.78A3.6,3.6,0,0,1,77.26,13c2.29,0,3.27,1.68,3.27,3.63a3.89,3.89,0,0,1-.11,1Zm2.08-1.75a1,1,0,0,0-1-1.15A1.17,1.17,0,0,0,76,15.86Z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "energia"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M83.57,16.72c0,2.22,1.21,3.08,2.63,3.08a4,4,0,0,0,1.91-.39l.17.55a4.54,4.54,0,0,1-2.17.45,3.18,3.18,0,0,1-3.21-3.49c0-2.3,1.32-3.74,3.1-3.74,2.26,0,2.69,2.13,2.69,3.12a1.63,1.63,0,0,1,0,.42Zm4.4-.54a2.13,2.13,0,0,0-2.06-2.44,2.46,2.46,0,0,0-2.3,2.44Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M89.72,15c0-.64,0-1.11-.06-1.66h.64l0,1.25h0a2.61,2.61,0,0,1,2.37-1.41c.66,0,2.4.33,2.4,2.92v4.15h-.67V16.16c0-1.25-.49-2.39-1.91-2.39a2.2,2.2,0,0,0-2.07,1.58,2.06,2.06,0,0,0-.1.62v4.28h-.68Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M96.81,16.72c0,2.22,1.2,3.08,2.63,3.08a4,4,0,0,0,1.91-.39l.17.55a4.57,4.57,0,0,1-2.17.45,3.18,3.18,0,0,1-3.22-3.49c0-2.3,1.32-3.74,3.11-3.74,2.25,0,2.68,2.13,2.68,3.12a1.63,1.63,0,0,1,0,.42Zm4.39-.54a2.12,2.12,0,0,0-2-2.44,2.46,2.46,0,0,0-2.3,2.44Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M103,15.41c0-.69,0-1.41-.06-2.07h.63l0,1.4h0a2.14,2.14,0,0,1,2-1.56l.27,0v.66a1.12,1.12,0,0,0-.33,0c-1,0-1.62.82-1.81,1.93a4.49,4.49,0,0,0-.06.66v3.82H103Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M111.84,19.24c0,1.77-.36,2.65-.94,3.2a3.44,3.44,0,0,1-2.34.82,3.93,3.93,0,0,1-2.18-.59l.24-.55a3.78,3.78,0,0,0,2,.57c1.45,0,2.5-.76,2.5-2.8v-1h0a2.59,2.59,0,0,1-2.4,1.34,3.13,3.13,0,0,1-3-3.4c0-2.4,1.58-3.67,3.11-3.67a2.45,2.45,0,0,1,2.33,1.33h0l0-1.17h.64c0,.52-.06,1.07-.06,1.78ZM111.16,16a2.65,2.65,0,0,0-.08-.66,2.25,2.25,0,0,0-2.15-1.59c-1.46,0-2.47,1.21-2.47,3,0,1.55.82,2.89,2.45,2.89A2.23,2.23,0,0,0,111,18.12a2.06,2.06,0,0,0,.13-.74Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M114.22,11.37a.56.56,0,0,1-.57.59.55.55,0,0,1-.53-.59.59.59,0,0,1,.56-.61A.56.56,0,0,1,114.22,11.37Zm-.89,8.88V13.34H114v6.91Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M119.9,18.61a12.78,12.78,0,0,0,.1,1.64h-.62l-.1-1h0a2.57,2.57,0,0,1-2.2,1.16,1.89,1.89,0,0,1-2-1.9c0-1.6,1.41-2.57,4.21-2.54V15.8c0-.69-.13-2.06-1.76-2a2.94,2.94,0,0,0-1.73.52l-.21-.51a3.68,3.68,0,0,1,2-.59c2,0,2.37,1.5,2.37,2.74Zm-.68-2.06c-1.51,0-3.49.19-3.49,1.84a1.32,1.32,0,0,0,1.38,1.44,2.07,2.07,0,0,0,2-1.38,1.32,1.32,0,0,0,.07-.42Z"
  }))), /*#__PURE__*/React.createElement("path", {
    id: "symbol",
    className: "cls-2",
    d: "M9.91,21.31a5.72,5.72,0,0,0-1.62,3.14A3.76,3.76,0,0,1,7.17,27.1a3.82,3.82,0,1,1-5.4-5.41,3.76,3.76,0,0,1,2.65-1.12h0A5.8,5.8,0,0,0,9.17,15.8h0a3.83,3.83,0,1,1,3.88,3.88h0A5.72,5.72,0,0,0,9.91,21.31Zm14.94-7.38a3.83,3.83,0,0,0-6.53,2.66h0a5.78,5.78,0,0,1-1.62,3.15,5.85,5.85,0,0,1-3.14,1.62,3.74,3.74,0,0,0-2.64,1.12,3.82,3.82,0,0,0,5.4,5.41,3.76,3.76,0,0,0,1.12-2.65,5.78,5.78,0,0,1,4.76-4.76h0a3.83,3.83,0,0,0,2.65-6.54ZM6.53,18.07a3.81,3.81,0,0,0,1.11-2.65,5.8,5.8,0,0,1,4.76-4.77h0a3.78,3.78,0,0,0,2.65-1.12A3.83,3.83,0,0,0,9.64,4.12,3.87,3.87,0,0,0,8.52,6.78h0A5.83,5.83,0,0,1,6.91,9.92a5.89,5.89,0,0,1-3.14,1.62h0a3.79,3.79,0,0,0-2.65,1.11,3.83,3.83,0,0,0,5.41,5.42Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgElergone);
export default __webpack_public_path__ + "static/media/elergone.fe5491cac34bca78d4284c102f94400b.svg";
export { ForwardRef as ReactComponent };